import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MultiSelect from '../MultiSelect';
import ApiClients from '../../../utils/apiClients';
import string2xml from '../../../utils/string2xml';
import xml2json from '../../../utils/xml2json';
import getDotProp from '../../../utils/getDotProp';

var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1
    }
  };
};

var getOptionProp = function getOptionProp(option, prop) {
  if (option['@attributes']) {
    //search in attributes
    return option['@attributes'][prop];
  }

  return null;
};

var itemToOption = function itemToOption(item, options) {
  return {
    item: item,
    label: getOptionProp(item, options.optionLabel),
    value: getOptionProp(item, options.optionValue)
  };
};

var xmlStringToOptions = function xmlStringToOptions(xmlString, options) {
  var json = xml2json(string2xml(xmlString));
  var items = getDotProp(json, options.options);
  var nodes = [];

  if (items) {
    if (items.length > 0) {
      return items.map(function (item) {
        return itemToOption(item, options);
      });
    } else if (typeof items === 'object') {
      //single entry
      return [itemToOption(items, options)];
    }
  }

  return nodes;
};
/**
 * @extends {React.Component<import('../types').FormInputDiagramSelectProps & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */


var DiagramSelectFormInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DiagramSelectFormInput, _React$Component);

  function DiagramSelectFormInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DiagramSelectFormInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DiagramSelectFormInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.loadInitialData = function (ids) {
      //not needed for now
      return Promise.resolve([]);
    };

    _this.loadData = function (inputValue) {
      var _this$props = _this.props,
          workspace = _this$props.workspace,
          path = _this$props.path,
          options = _this$props.options,
          optionLabel = _this$props.optionLabel,
          optionValue = _this$props.optionValue,
          itemsPerPage = _this$props.itemsPerPage;
      return ApiClients.directData.get({
        workspace: workspace,
        path: path,
        parameters: {
          filter: inputValue,
          page: '0',
          itemsPerPage: itemsPerPage.toString()
        }
      }).then(function (data) {
        return xmlStringToOptions(data, {
          options: options,
          optionLabel: optionLabel,
          optionValue: optionValue
        });
      });
    };

    return _this;
  }

  _createClass(DiagramSelectFormInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          onChange = _this$props2.onChange,
          style = _this$props2.style,
          rest = _objectWithoutProperties(_this$props2, ["classes", "onChange", "style"]);

      return React.createElement("div", {
        className: classes.root,
        style: style
      }, React.createElement(MultiSelect, Object.assign({
        onChange: onChange,
        onLoad: this.loadData,
        onInitialLoad: this.loadInitialData
      }, rest)));
    }
  }]);

  return DiagramSelectFormInput;
}(React.Component);

DiagramSelectFormInput.defaultProps = {
  multi: false,
  itemsPerPage: 20
};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECDiagramSelectFormInput'
})(DiagramSelectFormInput);